/* loading-state.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import "./loading-state.compiled.css";
import { forwardRef } from 'react';
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { AssetsAqlSearchInputSkeleton } from './aql-search-input/loading-state';
import { AssetsObjectSchemaSelectSkeleton } from './object-schema-select/loading-state';
import { FormRowContainer } from './styled';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
var SchemaSelectContainer = forwardRef(function (_ref, __cmplr) {
  var _ref$as = _ref.as,
    C = _ref$as === void 0 ? "div" : _ref$as,
    __cmpls = _ref.style,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1bsb1osq _p12ffkat", __cmplp.className])
  }));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
if (process.env.NODE_ENV !== 'production') {
  SchemaSelectContainer.displayName = 'SchemaSelectContainer';
}
var FormContainer = forwardRef(function (_ref2, __cmplr) {
  var _ref2$as = _ref2.as,
    C = _ref2$as === void 0 ? "form" : _ref2$as,
    __cmpls = _ref2.style,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c11p5 _1p57pxbi _1bsb1osq", __cmplp.className])
  }));
});
if (process.env.NODE_ENV !== 'production') {
  FormContainer.displayName = 'FormContainer';
}
export var AssetsSearchContainerLoading = function AssetsSearchContainerLoading(_ref3) {
  var modalTitle = _ref3.modalTitle;
  return /*#__PURE__*/React.createElement(FormContainer, {
    "data-testid": "assets-datasource-modal--search-container-skeleton"
  }, /*#__PURE__*/React.createElement(FormRowContainer, {
    isNarrowGap: true
  }, modalTitle, /*#__PURE__*/React.createElement(SchemaSelectContainer, null, /*#__PURE__*/React.createElement(AssetsObjectSchemaSelectSkeleton, null))), /*#__PURE__*/React.createElement(FormRowContainer, null, /*#__PURE__*/React.createElement(AssetsAqlSearchInputSkeleton, null)));
};